module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-view"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "method": "get"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit()
      }
    }
  }, [(_vm.error) ? _c('p', {
    staticClass: "tip error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-user"
  }, [_c('label', [_c('strong', [_vm._v("邮箱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, _vm.updateData]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-pwd"
  }, [_c('label', [_c('strong', [_vm._v("请输入密码")]), _vm._v(" "), (_vm.passType === 'password') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    attrs: {
      "type": "password",
      "name": "token",
      "placeholder": "Token"
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }, _vm.updateData]
    }
  })] : _vm._e(), _vm._v(" "), (_vm.passType === 'text') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    attrs: {
      "type": "text",
      "name": "token",
      "placeholder": "Token"
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }, _vm.updateData]
    }
  })] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "show-pwd",
    class: {
      show: _vm.isShow
    },
    on: {
      "click": function($event) {
        _vm.showPwd()
      }
    }
  })], 2)]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "submit",
    class: {
      disabled: _vm.isDisabled
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isDisabled
    }
  }, [_vm._v("\n        " + _vm._s(_vm.loginState) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "more-login"
  }, [_vm._v("使用其他方式登录 & 找回密码")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'RegisterView'
      }
    }
  }, [_vm._v("注册豆瓣帐号")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("下载豆瓣App")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('a', {
    attrs: {
      "href": "javascript:history.go(-1);"
    }
  }, [_vm._v("取消")]), _vm._v("登录豆瓣\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d75ddaf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LoginView.vue
// module id = 208
// module chunks = 0